import './service-item-tooltip.scss';
import { Tooltip } from 'antd';
import CustomIcon, { IconType } from '../../../shared/custom-icon/custom-icon';

interface ServiceItemTooltipProps {
    title: string;
    descriptionList: string[];
}

export const ServiceItemTooltip: React.FC<ServiceItemTooltipProps> = ({ title, descriptionList }) => {

    if (!descriptionList?.length && !title) return null;

    const createDescriptionContent = () => {
        return <div className="tooltip-content">
            <div className="title">{title}</div>
            {descriptionList?.map((description) => <div key={description}
                className={`description-wrapper ${descriptionList.length === 1 ? 'one-item' : ''}`}>
                { !!description.length && <>
                    <span className="bullet"/>
                    <span className="description">{description}</span>
                </>}
            </div>)}
        </div>;
    };

    return <Tooltip placement="bottomRight" title={createDescriptionContent()} overlayClassName={'service-item-tooltip'} color="white" showArrow={false}>
        <CustomIcon type={IconType.INFO} size={24}/>
    </Tooltip>;
};
